import { NavLink } from 'react-router-dom'
import './index.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome, faImages, faDollarSign, faScrewdriverWrench, faQuestion, faBars, faClose } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

const Sidebar = () => {

    const [showNav, setShowNav] = useState(false); //can see the menu when set to true// can see the hamburger icon when set to false 

    return (

        <div className="nav-bar">

            <nav className={showNav ? 'mobile-show' : ''}>
                <NavLink exact="true" activeclassname="active" to="/" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="services-link" to="/services" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faScrewdriverWrench} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="portfolio-link" to="/portfolio" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faImages} color="#4d4d4e" />
                </NavLink>
                <NavLink exact="true" activeclassname="active" className="pricing-link" to="/pricing" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faDollarSign} color="#4d4d4e" />
                </NavLink>
                <a className="faq-link" href="/pricing#faq" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faQuestion} color="#4d4d4e" />
                </a>
                <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact" onClick={() => setShowNav(false)}>
                    <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
                </NavLink>
            </nav>

            {/* <ul>
                <li>
                    <a
                        target="_blank"
                        rel='noreferrer'
                        href="https://www.linkedin.com/in/karidouglas/">
                        <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
                    </a>
                </li>
                <li>
                    <a target="_blank"
                        rel='noreferrer'
                        href="https://github.com/kouglas">
                        <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
                    </a>
                </li>



            </ul> */}


            <FontAwesomeIcon
                onClick={() => setShowNav(true)}
                icon={faBars}
                color="#AD7DE3"
                size="2x"
                className='hamburger-icon' />
            <FontAwesomeIcon
                onClick={() => setShowNav(false)}
                icon={faClose}
                color="#AD7DE3"
                size="3x"
                className='close-icon' />
        </div>
    )

}

export default Sidebar